import { PropsWithChildren } from 'react';

type ChatSkeletonContainerProps = PropsWithChildren;

export const ChatSkeletonContainer: React.FC<ChatSkeletonContainerProps> = ({ children }) => {
  return children;
};
